export const communityLinks = [
  {
    id: 1,
    name: 'Incubator/Accelerator',
    link: '/'
  },
  {
    id: 2,
    name: 'Corporations',
    link: '/'
  }, 
  {
    id: 3,
    name: 'Startups',
    link: '/'
  },
  {
    id: 4,
    name: 'Investor',
    link: '/'
  },
  {
    id: 5,
    name: 'Open Challenges',
    link: '/'
  }
]

export const modulesLinks = [
  {
    id: 1,
    name: 'Coaching Module',
    link: '/'
  },
  {
    id: 2,
    name: 'Data Module',
    link: '/'
  }, 
  {
    id: 3,
    name: 'Ecosystem Module',
    link: '/'
  },
  {
    id: 4,
    name: 'LMS Module',
    link: '/'
  },
  {
    id: 5,
    name: 'Events',
    link: '/'
  },
  {
    id: 6,
    name: 'Application Processing',
    link: '/'
  }
]

export const companyLinks = [
  {
    id: 1,
    name: 'About Us',
    link: '/'
  },
  {
    id: 2,
    name: 'Careers',
    link: '/'
  }, 
  {
    id: 3,
    name: 'Blog',
    link: '/'
  },
  {
    id: 4,
    name: 'Pricing',
    link: '/'
  },
  {
    id: 5,
    name: 'Contact Us',
    link: '/'
  }
]

export const documentationLinks = [
  {
    id: 1,
    name: 'Documentation',
    link: '/'
  },
  {
    id: 2,
    name: 'Release Log',
    link: '/'
  }, 
  {
    id: 3,
    name: 'FAQ',
    link: '/'
  },
  {
    id: 4,
    name: 'Legal',
    link: '/'
  }
]
